


















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import { find, head } from 'lodash';
import { mapActions } from 'vuex';

@Component({
    methods: {
        ...mapActions({
            closeDialog: Actions.HIDE_CAMERA_DIALOG,
            cancelImageCapture: Actions.CANCEL_IMAGE_CAPTURE,
        }),
    },
})
export default class ImageCapture extends Vue {
    private img: any | null = null;
    private camera: any | null = null;
    private deviceId: any | null = null;
    private devices: any[] = [];

    constructor() {
        super();
    }

    get device() {
      return find(this.devices, (n: any) => n.deviceId === this.deviceId);
    }

    public capturePhoto() {
        const webcamRef = (this.$refs.webcam as any);

        this.$store.commit(Mutations.SAVE_CAPTURED_IMAGE_DATA, {
            meta: {
                width: webcamRef.$el.width,
                height: webcamRef.$el.height,
            },
            data: webcamRef.capture(),
        });

        this.onStop();

        this.$store.dispatch(Actions.HIDE_CAMERA_DIALOG);
    }

    @Watch('camera')
    private cameraWatcher(id: any) {
        this.deviceId = id;
    }

    @Watch('devices')
    private devicesWatcher() {
        const first = head(this.devices);

        if (first) {
            this.camera = first.deviceId;
            this.deviceId = first.deviceId;
        }
    }

    private onCapture() {
        this.img = (this.$refs.webcam as any).capture();
    }

    private onStarted(stream: any) {
    }

    private onStopped(stream: any) {
    }

    private onStop() {
        (this.$refs.webcam as any).stop();
    }

    private onStart() {
        (this.$refs.webcam as any).start();
    }

    private onError(error: any, stream: any) {
    }

    private onCameras(cameras: any) {
        this.devices = cameras;
    }

    private onCameraChange(deviceId: any) {
        this.deviceId = deviceId;
        this.camera = deviceId;
    }

}
